const e = {
  revocation: "revocation",
  unscheduledRepayment: "unscheduledRepayment"
};
export {
  e as GRANT_ADJUSTMENT_DETAILS
};
